
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE'

export const updateLanguage = ({ messages, language, name, icon }) => ({
  type: UPDATE_LANGUAGE,
  payload: { messages, language, name, icon }
})
